import React from "react";

export default function CareerPerks() {
    return (
        <section className="section section--soft">
            <div className="container">
                <h2 className="h-lg section-title">Why you'll like it here.</h2>
                <div className="feature-3">
                    <div className="feature-card">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 0-2.5-2.5H3V2z"></path>
                                <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 1 2.5-2.5H21V2z"></path>
                            </svg>
                        </div>
                        <h3>Real ownership</h3>
                        <p>Small, senior teams mean your work ships — and you see the impact of it.</p>
                    </div>
                    <div className="feature-card">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                <path d="M12 20v-6"></path>
                                <path d="M6 20V10"></path>
                                <path d="M18 20V4"></path>
                            </svg>
                        </div>
                        <h3>Room to grow</h3>
                        <p>Mentorship, new tech and the freedom to lead — we back people who take initiative.</p>
                    </div>
                    <div className="feature-card">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <h3>Balanced culture</h3>
                        <p>A vibrant, supportive team that respects your time and celebrates good work.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
